export const securityEs = {
    securityBanner: {
        title: "Seguridad para proteger datos críticos y habilitar la innovación",
        subTitle: "Ayudamos a organizaciones a reducir riesgos de ciberataques, fugas de información y uso no gobernado de IA, integrando seguridad a la operación diaria.",
        buttonConsult: "Habla con un especialista",
    },
    securityChallengeToday: {
        title: "El desafío hoy",
        description: "La seguridad ya no es un tema exclusivo de IT: es un desafío estratégico que impacta en continuidad operativa, reputación y cumplimiento.\n\n En un entorno con ciberataques más frecuentes, data breaches y adopción acelerada de cloud e IA, los controles aislados no alcanzan. La organización necesita un modelo consistente para prevenir, detectar y responder sin frenar la operación.",
        cards: [
            {
                id: 1,
                icon: "shield-exclamation",
                title: "Superficie de ataque en expansión",
                description: "El trabajo remoto, el acceso desde múltiples dispositivos, las nubes híbridas y el crecimiento de aplicaciones SaaS diluyen el perímetro tradicional. La identidad se convierte en el principal vector de ataque si no se gestiona con criterios de Zero Trust.",
                iconSize: 64,
                iconStroke: 2,
            },
            {
                id: 2,
                icon: "cloud-lock-open",
                title: "Aumento de incidentes y fugas de información",
                description: "La ausencia de reglas sobre calidad, catalogación y responsabilidades impide demostrar origen, uso y confiabilidad de los datos, exponiendote a reprocesos y riesgos de cumplimiento.",
                iconSize: 64,
                iconStroke: 2,
            },
            {
                id: 3,
                icon: "file-text-shield",
                title: "Uso de IA sin controles claros",
                description: "La adopción de IA generativa, incluyendo herramientas no autorizadas o Shadow AI, introduce nuevos riesgos de exposición de información sensible, uso indebido de datos y problemas de compliance si no se gobierna desde el inicio.",
                iconSize: 64,
                iconStroke: 2,
            },
        ],
        footer: "El desafío no es solo defenderse de ataques, sino operar de forma segura, confiable y preparada para escalar.",
    },
    securityApproach: {
        title: "Cómo abordamos este desafío",
        items: [
            {
                icon: "home-shield",
                text: "En Possumus abordamos la seguridad como un habilitador estratégico: el objetivo es reducir riesgo operativo y sostener la continuidad, no “sumar controles” sin impacto.",
            },
            {
                icon: "cloud-lock",
                text: "Nuestro enfoque combina Zero Trust, gobierno de identidades y protección de la información sobre el ecosistema Microsoft Security, integrando prevención, detección y respuesta.",
            },
            {
                icon: "heart-handshake",
                text: "Trabajamos de forma progresiva, adaptándonos a la madurez de cada organización, para construir una base operable y sostenible (políticas, configuración, monitoreo y prácticas de trabajo).",
            },
        ],
    },
    securityGovernanceProgram: {
        title: "Seguridad Zero Trust y Protección de Información",
        subtitle: "",
        partners: [
            { name: "entra", logo: "entra" },
            { name: "defender", logo: "defender" },
            { name: "sentinel", logo: "sentinel" },
            { name: "intune", logo: "intune" },
            { name: "microsoft-purview", logo: "microsoft-purview" },
        ],
        cardsTitle: "La práctica de Seguridad de Possumus se estructura según el nivel de madurez, riesgo y contexto de cada organización.\n\n Las iniciativas pueden ser:",
        cards: [
            {
                id: 1,
                icon: "user-plus",
                iconSize: 64,
                iconStroke: 2,
                title: "Training",
                description: "Capacitación técnica y funcional para equipos de IT, seguridad y datos.",
            },
            {
                id: 2,
                icon: "rocket",
                iconSize: 64,
                iconStroke: 2,
                title: "Deployment",
                description: "Diseño e implementación de controles, configuraciones y arquitecturas de seguridad sobre el ecosistema Microsoft.",
            },
            {
                id: 3,
                icon: "message-2-plus",
                iconSize: 64,
                iconStroke: 2,
                title: "Strategic consulting",
                description: "Definición de modelos de seguridad, Zero Trust, gobierno, priorización de riesgos y roadmap evolutivo.",
            }
        ],
    },
    securityObjective: {
        title: "Cómo trabajamos",
        description: "",
        pills: [
            {
                icon: "calendar-event",
                text: "Programa progresivo y adaptable",
            },
            {
                icon: "users",
                text: "Equipo Possumus + referentes internos",
            },
            {
                icon: "shield-plus",
                text: "Seguridad integrada a la operación",
            },
            {
                icon: "users-group",
                text: "Trabajo colaborativo on-site y remoto",
            },
        ]
    },
    securityActivities: {
        title: "Qué habilita esta práctica",
        stackTitle: "Componentes clave",
        cards: [
            {
                id: 1,
                icon: "user-cog",
                title: "Gobierno de identidades y accesos",
                description: "Diseñamos e implementamos modelos de Identity & Access Management basados en Zero Trust, con control de privilegios, accesos just-in-time y criterios de riesgo adaptativo, reduciendo el impacto de credenciales comprometidas.",
                stack: [
                    "Entra ID", "MFA avanzando", "PIM", "acceso condicional"
                ],
            },
            {
                id: 2,
                icon: "eye-check",
                title: "Protección frente a amenazas y monitoreo",
                description: "Habilitamos la clasificación, protección y uso seguro de datos sensibles a lo largo de todo su ciclo de vida, desde la creación hasta el intercambio y almacenamiento, sin depender exclusivamente del comportamiento del usuario.",
                stack: [
                    "Microsoft Defender XDR", "Sentinel (SIEM/SOAR)"
                ],
            },
            {
                id: 3,
                icon: "box-multiple",
                title: "Gestión segura de dispositivos",
                description: "Aseguramos que solo dispositivos confiables y conformes accedan a los recursos corporativos, incluso en escenarios BYOD y movilidad.",
                stack: [
                    "Microsoft Intune", "compliance de endpoints"
                ]
            },
            {
                id: 4,
                icon: "shield-check",
                title: "Protección de datos y uso responsable de IA",
                description: "Protegemos información sensible y gobernamos su uso en aplicaciones, colaboración e inteligencia artificial, minimizando riesgos de fuga y exposición.",
                stack: [
                    "Microsoft Purview", "DLP", "Insider Risk", "preparación segura para Copilot"
                ],
            },
        ],
    },
    securityExpectedResults: {
        title: "Resultados esperados",
        description: "Una estrategia de seguridad bien implementada se refleja en menor exposición al riesgo y mayor capacidad de escalar tecnología con confianza.",
        cards: [
            {
                id: 1,
                icon: "shield-check",
                title: "Menor riesgo de incidentes críticos",
                description: "Reducción de accesos indebidos, privilegios excesivos y vectores comunes de ataque basados en identidad.",
            },
            {
                id: 2,
                icon: "eye-check",
                title: "Mayor control sobre datos sensibles",
                description: "Clasificación, protección y uso controlado de la información, incluso en entornos colaborativos y con IA generativa.",
            },
            {
                id: 3,
                icon: "shield-search",
                title: "Capacidad de detección y respuesta madura",
                description: "Visibilidad integrada y procesos claros para responder ante incidentes, con evidencia técnica y operacional.",
            },
            {
                id: 4,
                icon: "rocket",
                title: "Base sólida para adopción de IA",
                description: "Condiciones de seguridad y gobierno que permiten avanzar con Copilot y otras soluciones de IA sin comprometer datos ni cumplimiento.",
            },
        ],
    },
    securityUseCases: {
        title: "Casos de uso en:",
        cards: [
            {
                id: 1,
                logo: "capex",
            },
            {
                id: 2,
                logo: "tassaroli",
            },
            {
                id: 3,
                logo: "veritran",
            },
        ],
    },
    securityCtaBanner: {
        title: "Protegé la información crítica de tu organización sin frenar la operación.",
        buttonText: "Conversemos",
        quote: "Protegé los datos y sistemas de tu organización frente a ciberataques, fugas de información y riesgos asociados al uso de IA, sin frenar la innovación.",
    },
    securityWhyPossumus: {
        title: "Por qué las empresas eligen Possumus",
        cards: [
            {
                id: 1,
                icon: "trophy",
                title: "Top 5 de partners de Microsoft en Argentina, certificados en las seis designaciones de Microsoft.",
                iconSize: 64,
                iconStroke: 1.5,
            },
            {
                id: 2,
                icon: "database-cog",
                title: "Especializaciones en Threat Protection e Identity & Access Management",
                iconSize: 64,
                iconStroke: 1.5
            },
            {
                id: 3,
                icon: "shield-check",
                iconSize: 64,
                iconStroke: 1.5,
                title: "Enfoque seguro y responsable, alineado con los principios de IA Responsable de Microsoft.",
            },
            {
                id: 4,
                icon: "certificate-2",
                iconSize: 64,
                iconStroke: 1.5,
                title: "Metodología acreditada ISO 9001:2015, que garantiza calidad y trazabilidad.",
            },
            {
                id: 5,
                icon: "heart-handshake",
                title: "Acompañamiento humano y técnico hasta lograr adopción real: no desplegamos, hacemos que funcione.",
                iconSize: 64,
                iconStroke: 1.5,
            }
        ],
    },
    microsoftPartner: {
        title: "Somos Top Partner de Microsoft,\n\nespecialistas en seguridad:",
        description: "designaciones",
    },
    softwareSection: {
        title: "¿Listo para contratar tu software?",
        subtitle: "Proceso simple y transparente",
        steps: [
            {
                id: 1,
                title: "1. Discovery call",
                description: "Conversamos sobre tus desafíos y objetivos de datos en una sesión de 30 minutos.",
            },
            {
                id: 2,
                title: "2. Propuesta personalizada",
                description: "Diseñamos una solución a medida con roadmap, equipo y pricing claro.",
            },
            {
                id: 3,
                title: "3. Kick-off rápido",
                description: "Arrancamos en menos de 2 semanas con tu equipo dedicado de data governance.",
            },
        ],
    },
    contact: {
        title: "Diseño de contacto",
        subtitle: "Hablemos de tus datos",
    },
};

export const securityEn = {
    securityBanner: {
  
      title: "Security to protect critical data and enable innovation",
      subTitle:
        "We help organizations reduce the risk of cyberattacks, data leaks, and ungoverned AI usage by embedding security into day-to-day operations.",
      buttonConsult: "Talk to a specialist",
    },
  
    securityChallengeToday: {
      title: "Today's challenge",
      description:
        "Security is no longer an IT-only concern, it is a strategic challenge that directly impacts operational continuity, reputation, and compliance.\n\nIn an environment of increasingly frequent cyberattacks, data breaches, and accelerated cloud and AI adoption, isolated controls are no longer sufficient. Organizations need a consistent, integrated model to prevent, detect, and respond without slowing down operations.",
      cards: [
        {
          id: 1,
          icon: "shield-exclamation",
          title: "An expanding attack surface",
          description:
            "Remote work, access from multiple devices, hybrid cloud environments, and the rapid growth of SaaS applications blur the traditional perimeter. Identity becomes the primary attack vector when it is not governed under Zero Trust principles.",
          iconSize: 64,
          iconStroke: 2,
        },
        {
          id: 2,
          icon: "cloud-lock-open",
          title: "Rising incidents and data leaks",
          description:
            "Cyberattacks and security incidents continue to increase, with identity remaining one of the most common points of compromise. Stolen credentials and limited visibility into who can access what allow relatively simple incidents to escalate quickly across the organization.",
          iconSize: 64,
          iconStroke: 2,
        },
        {
          id: 3,
          icon: "file-text-shield",
          title: "AI adoption without clear control",
          description:
            "Generative AI Adoption, including unauthorized tools and Shadow AI, introduces new risks related to sensitive data exposure, misuse of information, and compliance gaps if governance is not established from the outset.",
          iconSize: 64,
          iconStroke: 2,
        },
      ],
      footer:
        "The challenge is not only to defend against attacks, but to operate securely, reliably, and with confidence to scale.",
    },
  
    securityApproach: {
      title: "How we address this challenge",
      items: [
        {
          icon: "home-shield",
          text: "At Possumus, we treat security as a strategic enabler:  the objective is to reduce operational risk and ensure continuity, not adding controls that increase complexity without impact.",
        },
        {
          icon: "cloud-lock",
          text: "Our approach combines Zero Trust, identity governance, and information protection across the Microsoft Security ecosystem, integrating prevention, detection, and response into a cohesive model.",
        },
        {
          icon: "heart-handshake",
          text: "We work progressively, adapting to each organization’s maturity level, to build an operable and sustainable security foundation, covering policies, configuration, monitoring, and day-to-day operational practices.",
        },
      ],
    },
  
    securityGovernanceProgram: {
      title: "Zero Trust Security & Information Protection",
      subtitle: "",
      partners: [
        { name: "entra", logo: "entra" },
        { name: "defender", logo: "defender" },
        { name: "sentinel", logo: "sentinel" },
        { name: "intune", logo: "intune" },
        { name: "microsoft-purview", logo: "microsoft-purview" },
      ],
      cardsTitle:
        "Possumus Security practice is structured around each organization’s maturity, risk profile, and operational context.\n\nInitiatives may include:",
      cards: [
        {
          id: 1,
          icon: "user-plus",
          iconSize: 64,
          iconStroke: 2,
          title: "Training",
          description: "Technical and functional enablement for IT, security, and data teams.",
        },
        {
          id: 2,
          icon: "rocket",
          iconSize: 64,
          iconStroke: 2,
          title: "Deployment",
          description:
            "Design and implementation of security controls, configurations, and architectures across the Microsoft ecosystem.",
        },
        {
          id: 3,
          icon: "message-2-plus",
          iconSize: 64,
          iconStroke: 2,
          title: "Strategic Consulting",
          description:
            "Definition of security and Zero Trust models, governance frameworks, risk prioritization, and an evolutionary roadmap.",
        },
      ],
    },
  
    securityObjective: {
      title: "How we work",
      description: "",
      pills: [
        {
          icon: "calendar-event",
          text: "Progressive and adaptable program",
        },
        {
          icon: "users",
          text: "Possumus team + internal stakeholders",
        },
        {
          icon: "shield-plus",
          text: "Security embedded into daily operations",
        },
        {
          icon: "users-group",
          text: "Collaborative delivery, both on-site and remote",
        },
      ],
    },
  
    securityActivities: {
      title: "What this practice enables",
      stackTitle: "Core components",
      cards: [
        {
          id: 1,
          icon: "user-cog",
          title: "Identity and access governance",
          description:
            "We design and implement Identity & Access Management models based on Zero Trust, incorporating privilege control, just-in-time access, and adaptive risk-based policies, reducing the impact of compromised credentials.",
          stack: ["Entra ID", "advanced MFA", "PIM", "conditional access"],
        },
        {
          id: 2,
          icon: "eye-check",
          title: "Threat protection and monitoring",
          description:
            "We enable classification, protection, and secure use of sensitive data throughout its entire lifecycle, from creation to sharing and storage, without relying exclusively on user behavior.",
          stack: ["Microsoft Defender XDR", "Sentinel (SIEM/SOAR)"],
        },
        {
          id: 3,
          icon: "box-multiple",
          title: "Secure device management",
          description:
            "We ensure that only trusted and compliant devices can access corporate resources, even in BYOD and mobile scenarios.",
          stack: ["Microsoft Intune", "endpoint compliance"],
        },
        {
          id: 4,
          icon: "shield-check",
          title: "Data protection and responsible AI usage",
          description:
            "We protect sensitive information and govern its use across applications, collaboration, and artificial intelligence, minimizing the risk of data leakage and exposure.",
          stack: ["Microsoft Purview", "DLP", "Insider Risk", "secure readiness for Copilot"],
        },
      ],
    },
  
    securityExpectedResults: {
      title: "Expected Results",
      description:
        "A well-implemented security strategy results in lower exposure risk and greater confidence to scale technology initiatives.",
      cards: [
        {
          id: 1,
          icon: "shield-check",
          title: "Reduced risk of critical incidents",
          description:
            "Fewer unauthorized accesses, excessive privileges, and common identity-based attack vectors.",
        },
        {
          id: 2,
          icon: "eye-check",
          title: "Greater control over sensitive data",
          description:
            "Consistent classification, protection, and controlled use of information, even in collaborative and generative AI scenarios.",
        },
        {
          id: 3,
          icon: "shield-search",
          title: "Mature detection and response capabilities",
          description:
            "Integrated visibility and clearly defined processes to respond to incidents, supported by technical and operational evidence.",
        },
        {
          id: 4,
          icon: "rocket",
          title: "Solid foundation for AI adoption",
          description:
            "Security and governance conditions that allow organizations to move forward with Copilot and other AI solutions without compromising data or compliance.",
        },
      ],
    },
  
    securityUseCases: {
      title: "Case studies",
      cards: [
        { id: 1, logo: "capex" },
        { id: 2, logo: "tassaroli" },
        { id: 3, logo: "veritran" },
      ],
    },
  
    securityCtaBanner: {
      title: "Protect your organization’s critical information without slowing down operations",
      buttonText: "Talk to a specialist",
      quote:
        "Protect your data and systems from cyberattacks, information leaks, and AI-related risks while continuing to innovate with confidence.",
    },
  
    securityWhyPossumus: {
      title: "Why companies choose Possumus",
      cards: [
        {
          id: 1,
          icon: "trophy",
          title: "Top 5 Microsoft partners in Argentina, certified across all six Microsoft designations",
          iconSize: 64,
          iconStroke: 1.5,
        },
        {
          id: 2,
          icon: "database-cog",
          title: "Advanced specializations in Threat Protection and Identity & Access Management",
          iconSize: 64,
          iconStroke: 1.5,
        },
        {
          id: 3,
          icon: "shield-check",
          iconSize: 64,
          iconStroke: 1.5,
          title: "Secure and responsible approach, aligned with Microsoft Responsible AI principles",
        },
        {
          id: 4,
          icon: "certificate-2",
          iconSize: 64,
          iconStroke: 1.5,
          title: "ISO 9001:2015–certified methodology, ensuring quality and traceability",
        },
        {
          id: 5,
          icon: "heart-handshake",
          title:
            "Human and technical guidance until real adoption is achieved. We don’t just deploy, we make it work",
          iconSize: 64,
          iconStroke: 1.5,
        },
      ],
    },
  
    microsoftPartner: {
      title: "We're a Top Microsoft Partner,\n\nspecialized in security:",
      description: "Designations",
    },
  
    softwareSection: {
      title: "Ready to build your software?",
      subtitle: "Simple and transparent process",
      steps: [
        {
          id: 1,
          title: "1. Discovery call",
          description: "We discuss your data challenges and objectives in a 30-minute session.",
        },
        {
          id: 2,
          title: "2. Custom proposal",
          description: "We design a tailored solution with a clear roadmap, team, and pricing.",
        },
        {
          id: 3,
          title: "3. Fast kick-off",
          description: "We start in less than 2 weeks with your dedicated data governance team.",
        },
      ],
    },
  
    contact: {
      title: "Contact design",
      subtitle: "Let's talk about your data",
    },
  };
  